import React from "react";
import ReactDOM from "react-dom";
import each from "lodash/each";
import CustomEvent from "custom-event";
import FAB from "../components/FAB";
import { Modal, MediaModal, PopupModal } from "../components/Modals";
import PostcodeModal from "../components/Postcode/PostcodeModal";
import { ScrollCue, ScrollToLocation } from "../components/ScrollCue";
import { SimpleCarousel, SimpleCarouselPayload } from "../components/SimpleCarousel";
import { Tabs, TabsPayload } from "../components/Tabs";
import { FullBgVideo } from "../components/FullBgVideo";
import { SocialCards } from "../components/SocialCards";
import { ModalAutoActions } from "../components/ModalAutoActions";
import { ThumbnailGallery } from "../components/ThumbnailGallery";
import ReadMore from "../components/ReadMore";
import SubscribeNowPopupContainer from "../containers/SubscribeNowPopupContainer";
import Render360Viewer from "../360Viewer";

const Global = () => {
  FullBgVideo();

  //Fab
  const fab = document.getElementById("fab");
  if (fab) {
    const fabContent = document.getElementById("fabLinks");
    ReactDOM.render(<FAB content={fabContent ? fabContent.innerHTML : ""} />, fab);
  }

  //Text Modal
  const textModal = document.createElement("div");
  if (textModal) {
    document.body.appendChild(textModal);
    ReactDOM.render(<Modal />, textModal);
  }

  //Image Modal
  const mediaModal = document.createElement("div");
  if (mediaModal) {
    document.body.appendChild(mediaModal);
    ReactDOM.render(<MediaModal />, mediaModal);
  }

  //Popup Modal
  const popupModal = document.createElement("div");
  if (popupModal) {
    document.body.appendChild(popupModal);
    ReactDOM.render(<PopupModal />, popupModal);
  }

  //Social Cards
  SocialCards();

  //Tabs
  each(document.querySelectorAll(".tabs"), scope => {
    if (scope.getAttribute("data-disableAutoInit")) {
      return;
    }

    let payload: TabsPayload = {
      scope,
      tabs: Array.prototype.map.call(scope.querySelectorAll(".tabs__item"), tab => tab),
      showNavButtons: scope.getAttribute("data-showNavButtons") || false
    };

    ReactDOM.render(<Tabs payload={payload} />, scope);
  });

  //SimpleSlider
  //This needs to run AFTER tabs to ensure sliders remain functional
  each(document.querySelectorAll(".sC"), scope => {
    if (scope.getAttribute("data-disableAutoInit")) {
      return;
    }

    let payload: SimpleCarouselPayload = {
      scope,
      slides: Array.prototype.map.call(scope.querySelectorAll(".sC__item"), slide => slide),
      startAt: parseInt(scope.getAttribute("data-sCStartAt")) || 0
    };

    ReactDOM.render(<SimpleCarousel payload={payload} />, scope);
  });

  //New Postcode Modal
  const pc = document.getElementById("pc");
  if (pc) {
    ReactDOM.render(<PostcodeModal content={window["PC_Content"]} />, pc);
  }

  const subscribeNowPopup = document.getElementById("subscribeNowPopup");
  if (subscribeNowPopup) {
    ReactDOM.render(<SubscribeNowPopupContainer />, subscribeNowPopup);
  }

  ScrollCue();
  ModalAutoActions();
  ThumbnailGallery();
  ReadMore();
  Render360Viewer();
};

export default Global;
